import React, { useEffect, useState } from 'react'; // Styles for the date picker
import './AssignedSpace.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faEdit, faCancel } from '@fortawesome/free-solid-svg-icons'; // Import appropriate icons
import { CustomOptionsDropdown } from './dropdown';
import './timePicker.css'
import { Image } from "@fluentui/react-components";
import Sidenav from './sidebar';
import "./work_place_excep.css";
import './timePicker.css';
import {
    Avatar,
    Menu,
    MenuTrigger,
    MenuList,
    MenuItem,
    MenuPopover,

} from "@fluentui/react-components";
import { useNavigate } from 'react-router-dom';
import { CustomTimePicker } from './timePicker';
import { getSettings } from '../../viewmodel/getsettings';
import { CommonInfo } from '../../CommonData/Config';
import { DeleteAction } from '../dialogues/dialogue-delete';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import ToastrService from '../toaster/ToastrService';
import moment from 'moment';
import GetSettingsService from '../../APIService/mySettingsService';
import LoginService from '../../APIService/loginservice';
import Swal from 'sweetalert2'
import { Dateformat } from './my-settings';
import {useTranslation} from "react-i18next"


const getSettingsData = getSettings;
type WorkplaceException = {
    Date: string;
    StartDateTime: string;
    EndDateTime: string;
    WorkingPlace: string;
    Id: any;
    Action: string;
};
const WorkSpaceExcption: React.FC = () => {
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [dateRanges, setDateRanges] = useState<{ Date: string; StartDateTime: string; EndDateTime: string; WorkingPlace: string; Id: any }[]>([
        { Date: '', StartDateTime: '', EndDateTime: '', WorkingPlace: '', Id: null },
    ]);
    const [workplaceexceptions, setWorkplaceexceptions] = useState<WorkplaceException>({
        Date: '', StartDateTime: '', EndDateTime: '', WorkingPlace: '', Id: null, Action: ''
    });
    const [currentIndex, setCurrentIndex] = useState(0);
    const deleteMessage1 = t('YouAboutToDeleteTheDataRelatedTo');
    const deleteMessage2 = t("ThisWillAlsoDeleteAllAssociatedDailyDataIncludingTheWorkplacePageAndSoForth")
    const deleteLabel = t("YesDeleteTheDataRelatedTo");
    const navigate = useNavigate();
    const userIdString = localStorage.getItem('userId'); // userIdString is of type string | null
    let userId: any;
    if (userIdString !== null) {
        userId = parseInt(userIdString); // Parse the value as an integer
    } else {
        console.error("userId is not found in localStorage");
    }
    const userEmail = localStorage.getItem('userEmail');

    const logOut = async () => {
        Swal.fire({
            title: t('LogoutConfirmation'),
            text: t('AreYouSureYouWantToLogout?'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t('No'),
            confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
            cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
            customClass: {
                popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
            },
            confirmButtonText: t("Yes")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const LogOut = await LoginService.logout();
                if (LogOut.data.ErrCode === '') {
                    localStorage.setItem('loggedIn', 'false');
                    navigate('/login');
                }
            }
        });

    }

    const setDateFormat = () => {
        const dateformat = localStorage.getItem('DateFormat')
        switch (dateformat) {
            case ('dd/MM/yyyy'):
                return 'DD/MM/YYYY';
            case ('MM/DD/YYYY'):
                return 'MM/DD/YYYY';
            case ('MMMM, DD, YYYY'):
                return 'MMMM, DD, YYYY';
            case ('MMMM, dddd D, YYYY'):
                return 'MMMM, dddd D, YYYY';
            case ('dddd, D MMMM YYYY'):
                return 'dddd, D MMMM YYYY';
            case ('dddd Do MMMM YYYY'):
                return 'DD/MM/YYYY';

            default:
                return 'DD/MM/YYYY';

        }
    }
    const dateFormat = setDateFormat();
    let startDate: any;
    const currentdate = new Date()
    useEffect(() => {
        getMySettings();
    }, [])

    useEffect(() => {
        initializeSelectedDate();

    }, [])
    const initializeSelectedDate = () => {
        const firstDayOfWeekString = getSettingsData.data.FirstDayOfWeek || localStorage.getItem('Firstdayofweek') || 'Sunday';
        const today = moment();
        let startOfWeek = today.clone().startOf('week').day(firstDayOfWeekString);

        // Adjust if the startOfWeek is after today, meaning we are in a new week
        if (startOfWeek.isAfter(today)) {
            startOfWeek.subtract(1, 'week');
        }
        startDate = getCurrentWeekDates(startOfWeek);
        setSelectedDate(startDate);

    };

    const getCurrentWeekDates = (startOfWeek: any) => {
        const weekDates = [];
        for (let i = 0; i < 7; i++) {
            const date = startOfWeek.clone().add(i, 'days');
            weekDates.push(date.toDate());
        }
        console.log("weekDates", weekDates);
        return weekDates;
    };

    const getMySettings = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                getSettingsData.data = getDataResult.data.d;
                getSettingsData.data.Is24HrFormat = getDataResult.data.d.Is24HrFormat
                localStorage.setItem('DateFormat', getDataResult.data.d.DateFormat)
                getSettingsData.data.DateFormat = getDataResult.data.d.DateFormat;
                // await setDateFormat();
                await GetWorklocation();
                await GetWorkPlacesList();

            }
        } catch (error) {
        }
    };
    const is24HrFormat = getSettingsData.data.Is24HrFormat;

    const converttoTimeString = (timeString: string) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}`;
    };
    const WeekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const [workLocations, setWorkLocations] = useState<{ [key: string]: { StartTime: string; EndTime: string; Place: string }[] }>(
        WeekDays.reduce((acc, day) => ({ ...acc, [day]: [] }), {})
    );

    let initialWorkLocations: any;

    const [remainingData, setRemainingData] = useState([]);
    const [allExceptions, setAllExceptions] = useState([]);
    const GetWorklocation = async () => {

        try {
            let data = {
                Id: userId,
                EmailAddress: userEmail,
                Date: moment().format('DD/MM/yyyy'),
                StartDateTime: moment().subtract(1, 'days').format('DD/MM/yyyy HH:mm'), // Current date and time
                EndDateTime: moment().endOf('year').format('DD/MM/yyyy HH:mm') // Last date of the current year at 23:59
            };

            const getResult = await GetSettingsService.GetWorkLocation(data);

            if (getResult.data.d) {
                getSettingsData.GetWorkLocationdata = getResult.data.d;
                setWorkLocations(getSettingsData.GetWorkLocationdata.DefaultWorkPlaces)
                getSettingsData.GetWorkLocationdata.WorkPlaceExceptions = getResult.data.d.WorkPlaceExceptions;

                if (!getSettingsData.GetWorkLocationdata.WorkPlaceExceptions) {
                    ToastrService.warning(t('NoRecordsFound'));
                    setDateRanges(() => [
                        {
                            Date: '',
                            StartDateTime: '',
                            EndDateTime: '',
                            WorkingPlace: '',
                            Id: null,
                        },
                    ]);
                } else {
                    const formattedExceptions = getSettingsData.GetWorkLocationdata.WorkPlaceExceptions.map((exception: any) => ({
                        ...exception,
                        Date: dayjs(exception.Date, 'DD/MM/YYYY').format(dateFormat),
                        StartDateTime: getSettingsData.data.Is24HrFormat
                            ? moment(exception.StartDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.StartDateTime, 'DD/MM/YYYY H:mm:ss').format('h:mm A'),
                        EndDateTime: getSettingsData.data.Is24HrFormat
                            ? moment(exception.EndDateTime, 'DD/MM/YYYY HH:mm:ss').format('H:mm')
                            : moment(exception.EndDateTime, 'DD/MM/YYYY H:mm:ss').format('h:mm A'),
                    }));
                    const EmptyIndex = {
                        Date: '',
                        StartDateTime: '',
                        EndDateTime: '',
                        WorkingPlace: '',
                        Id: null,
                    }

                    const sortedExceptions = formattedExceptions.sort((a: any, b: any) => {
                        const dateA: any = new Date(a.Date.split('/').reverse().join('-'));
                        const dateB: any = new Date(b.Date.split('/').reverse().join('-'));

                        if (dateA - dateB !== 0) {
                            return dateA - dateB; // Sort by Date
                        } else {
                            // If dates are the same, sort by StartDateTime
                            const timeA: any = new Date(a.StartDateTime.split('/').reverse().join('-'));
                            const timeB: any = new Date(b.StartDateTime.split('/').reverse().join('-'));
                            return timeA - timeB;
                        }
                    });
                    sortedExceptions.unshift(EmptyIndex);

                    // Store the entire list of exceptions but only display the initial slice
                    setAllExceptions(sortedExceptions);
                    setDateRanges(sortedExceptions.slice(0, 11));
                }
            }
        } catch (error) {
            console.error(error);
        }

    }

    const GetWorkPlacesList = async () => {
        try {
            const data =
            {
                "UserId": userId,
                "EmailAddress": userEmail,
                "LocationId": getSettingsData.data.DefaultLocation?.LocationId ? getSettingsData.data.DefaultLocation?.LocationId : null

            }


            // {
            //     "UserId": 1003,
            //     "EmailAddress": "vijay.manickam@qedas.com",
            //     "LocationId": 98
            // }

            const getResult = await GetSettingsService.GetWorkPlacesList(data);
            if (getResult.data.d) {
                getSettingsData.workPlacelist = getResult.data.d.WorkPlaces;
                if (getSettingsData.workPlacelist.length <= 0) {
                    getSettingsData.workPlacelist = [
                        {
                            Id: 0,
                            Name: t('NoDataAvailable'),
                            IconPath: "",
                            LocationId: 0
                        }
                    ]

                }

            }
        } catch (error) {

        }
    }
    const handleDelete = (Date: any, StartDateTime: any, EndDateTime: any, WorkingPlace: any, Id: any, index: number) => {
        setWorkplaceexceptions({ Date: Date, StartDateTime: StartDateTime, EndDateTime: EndDateTime, WorkingPlace: WorkingPlace, Id: Id, Action: 'Remove' })
        DeleteExceptions(Date, StartDateTime, EndDateTime, WorkingPlace, Id)
    };

    const DeleteExceptions = async (Date: any, StartDateTime: any, EndDateTime: any, WorkingPlace: any, Id: any) => {
        const formattedStarttime = convertToTimeString(StartDateTime, parseAndFormatDate(Date))
        const formattedDtime = convertToTimeString(EndDateTime, parseAndFormatDate(Date))
        const updatedWorkplaceExceptions = {
            ...workplaceexceptions,
            Date: parseAndFormatDate(Date),
            StartDateTime: formattedStarttime,
            EndDateTime: formattedDtime,
            WorkingPlace: WorkingPlace,
            Id: Id,
            Action: 'Remove'
        }

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: workLocations,
                WorkPlaceExceptions: [updatedWorkplaceExceptions]
            };
            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlaceExceptionHasBeenDeletedSuccessfully'));

                await getMySettings();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
            console.error('Error in Work Place Exception:', error);
        }


    }

    const handleSave = async (Date: any, StartTime: any, EndTime: any, WorkLocation: any, Id: number, i: number) => {
        const RangeDate = parseAndFormatDate(Date)
        const newRangeStartTime = moment(`${RangeDate} ${StartTime}`, 'DD/MM/YYYY HH:mm');
        const newRangeEndTime = moment(`${RangeDate} ${EndTime}`, 'DD/MM/YYYY HH:mm');

        // Check for overlap with existing date ranges
        const isOverlap = dateRanges.some((range, index) => {
            if (index === i) {
                return false; // Skip the current range being edited
            }
            const rangeStartTime = moment(`${range.Date} ${range.StartDateTime}`, 'DD/MM/YYYY HH:mm');
            const rangeEndTime = moment(`${range.Date} ${range.EndDateTime}`, 'DD/MM/YYYY HH:mm');
            return (
                newRangeStartTime.isBefore(rangeEndTime) && newRangeEndTime.isAfter(rangeStartTime) ||
                newRangeStartTime.isSameOrAfter(rangeStartTime) && newRangeEndTime.isSameOrBefore(rangeEndTime)
            );
        });

        if (Date && StartTime && EndTime && WorkLocation) {
            if (isOverlap) {
                setDateRanges((prevRanges: any) => {
                    const updatedRanges = [...prevRanges];
                    updatedRanges[i] = {
                        Date: '',
                        StartDateTime: '',
                        EndDateTime: '',
                        WorkingPlace: '',
                        Id: 0,
                    };
                    return updatedRanges;
                });

                return;
            }

            const newRange = {
                Date,
                StartDateTime: StartTime,
                EndDateTime: EndTime,
                WorkingPlace: WorkLocation,
                Id,
                Action: Id === null ? 'Add' : undefined,
            };

            if (i === 0) {
                setDateRanges((prevRanges: any) => [
                    {
                        Date: '',
                        StartDateTime: '',
                        EndDateTime: '',
                        WorkingPlace: '',
                        Id: 0,
                    },
                    newRange,
                    ...prevRanges.slice(1),
                ].sort((a, b) => (moment(a.Date, 'DD/MM/YYYY').isAfter(moment(b.Date, 'DD/MM/YYYY')) ? 1 : -1)));

                dateRanges.forEach((v: any) => {
                    v.Action = "Add";
                });

                const updatedLocations = await updateWorkLocations();

                try {
                    const data = {
                        Id: userId,
                        EmailAddress: userEmail,
                        DefaultWorkPlaces: workLocations,
                        WorkPlaceExceptions: [updatedLocations[0]]
                    };
                    const getDataResult = await GetSettingsService.SetWorklocation(data);
                    if (getDataResult.data && getDataResult.data?.Updated) {
                        ToastrService.success(t('YourWorkPlaceExceptionHasBeenSaved'));
                        initializeSelectedDate();
                        getMySettings();
                    } else {
                        ToastrService.error(getDataResult.data?.ErrDesc);
                    }
                } catch (error) {
                    console.error('Error in Work Place Exception:', error);
                }
            } else {
                EditExceptions(Date, StartTime, EndTime, WorkLocation, Id);

                setDateRanges((prevRanges: any) => {
                    const updatedRanges = [...prevRanges];
                    updatedRanges[i] = newRange;
                    return updatedRanges.sort((a, b) => (moment(a.Date, 'DD/MM/YYYY').isAfter(moment(b.Date, 'DD/MM/YYYY')) ? 1 : -1));
                });
            }
            setCurrentIndex(0);
        } else {
            ToastrService.warning(t('PleaseSelectAllTheFields'));
        }
    };

    function parseAndFormatDate(date: string | number | Date | dayjs.Dayjs | null | undefined) {

        const parsedDate = dayjs(date, dateFormat, true); // Strict mode
        if (parsedDate.isValid()) {
            return parsedDate.format("DD/MM/YYYY");
        }
        // If no format matches, return the original date
        return dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : date;
    }

    const EditExceptions = async (Date: any, StartDateTime: any, EndDateTime: any, WorkingPlace: any, Id: any) => {
        const formattedStarttime = convertToTimeString(StartDateTime, parseAndFormatDate(Date))
        const formattedDtime = convertToTimeString(EndDateTime, parseAndFormatDate(Date))
        const updatedWorkplaceExceptions = {
            ...workplaceexceptions,
            Date: parseAndFormatDate(Date),
            StartDateTime: formattedStarttime,
            EndDateTime: formattedDtime,
            WorkingPlace: WorkingPlace,
            Id: Id,
            Action: 'Edit'
        }

        try {
            const data = {
                Id: userId,
                EmailAddress: userEmail,
                DefaultWorkPlaces: workLocations,
                WorkPlaceExceptions: [updatedWorkplaceExceptions]
            };
            const getDataResult = await GetSettingsService.SetWorklocation(data);
            if (getDataResult.data && getDataResult.data?.Updated) {
                ToastrService.success(t('YourWorkPlaceExceptionHasBeenEditedSuccessfully'));
                initializeSelectedDate();
                getMySettings();
            } else {
                ToastrService.error(getDataResult.data?.ErrDesc);
            }
        } catch (error) {
            console.error('Error in Work Place Exception:', error);
        }


    }

    const updateWorkLocations = () => {
        const updatedWorkLocations = [...dateRanges];
        const updatedTimes = updatedWorkLocations.map(item => ({
            ...item,
            Date: parseAndFormatDate(item.Date),
            StartDateTime: convertToTimeString(item.StartDateTime, parseAndFormatDate(item.Date)),
            EndDateTime: convertToTimeString(item.EndDateTime, parseAndFormatDate(item.Date))
        }));
        return updatedTimes;


    };


    const convertToTimeString = (timeString: string, Selecteddate: any) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        // const Targetdate = moment(Selecteddate).format('DD/MM/YYYY')
        return `${Selecteddate} ${formattedHours}:${formattedMinutes}`;
    };

    const handleDateChange = (dates: [Date | null, Date | null], dateStrings: any, index: any) => {
        setDateRanges((prevRanges) => [
            ...prevRanges.slice(0, index),
            {
                ...prevRanges[index],
                Date: dateStrings,
            },
            ...prevRanges.slice(index + 1),
        ]);
    };


    const handleTimeChange = (index: number, type: 'StartDateTime' | 'EndDateTime', time: any) => {
        if (time.selectedTime !== null) {
            const formattedTime = formatDateToTimeString(time.selectedTime);
            const newTime = moment(time.selectedTime).format('HH:mm a');
            if (type === 'EndDateTime' && dateRanges[index].StartDateTime) {
                const startTime = moment(dateRanges[index].StartDateTime, 'HH:mm a');
                if (startTime.isValid() && moment(newTime, 'HH:mm a').isBefore(startTime)) {
                    ToastrService.warning(t('EndTimeMustBeLaterThanTheStartTime'));
                    return;
                }
            }
            if (type === 'StartDateTime' && dateRanges[index].EndDateTime) {
                const endTime = moment(dateRanges[index].EndDateTime, 'HH:mm a');
                if (endTime.isValid() && moment(newTime, 'HH:mm a').isAfter(endTime)) {
                    ToastrService.warning(t('StartTimeMustBeEarlierThanTheEndTime'));
                    return;
                }
            }

            setDateRanges((prevRanges) => [
                ...prevRanges.slice(0, index),
                {
                    ...prevRanges[index],
                    [type]: formattedTime,
                },
                ...prevRanges.slice(index + 1),
            ]);
        }
    };

    const formatDateToTimeString = (date: any) => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

        return is24HrFormat ? `${hours}:${formattedMinutes}` : timeString;
    };

    const handleDropdownChange = (index: number, WorkLocation: any) => {
        setDateRanges((prevRanges) => [
            ...prevRanges.slice(0, index),
            {
                ...prevRanges[index],
                WorkingPlace: WorkLocation,
            },
            ...prevRanges.slice(index + 1),
        ]);

    }

    const getIndex = (Date: any, StartDateTime: any, EndDateTime: any, WorkingPlace: any, Id: any, index: number) => {
        setWorkplaceexceptions({ Date: Date, StartDateTime: StartDateTime, EndDateTime: EndDateTime, WorkingPlace: WorkingPlace, Id: Id, Action: 'Remove' })
        setCurrentIndex(index);
    }

    const theme = localStorage.getItem('Theme')

    const openCalendar = () => {

        if (localStorage.getItem('Theme') === 'dark') {
            document.body.classList.add('dark-theme');

        }
    }

    const goBack = () => {
        navigate('/workplace');
    }

    const isDayDisabled = (date: any) => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(date).format('dddd');
        const currentDate = dayjs();

        // Extract dates from dateRanges
        const disabledDates = dateRanges.map(range => dayjs(range.Date, dateFormat).format('DD/MM/YYYY'));

        // Check if the day is a working day, if the date is in the past, or if the date is in dateRanges
        return workingDays[dayOfWeek] === false
            || dayjs(date).isBefore(currentDate, 'day')

    };
    let totalcount: any = 0;
    const [count, setCount] = useState(0);
    const handleLoadMore = () => {
        const newCount = count + 1;
        setCount(newCount);
        totalcount = newCount;
        const newDataToShow = allExceptions.slice(0, newCount * 11 + 11); // Add 11 more records each time
        setDateRanges(newDataToShow);
    };

    // Handle Load Less (if needed)
    const handleLoadLess = () => {
        const newCount = 0;
        setCount(newCount);
        totalcount = newCount;
        const newDataToShow = allExceptions.slice(0, newCount * 11 + 11); // Add 11 more records each time
        setDateRanges(newDataToShow);
    };

    return (
        <div className={`sidenav-container`}>
            <Sidenav authToken={null} LoguserName={null} />
            <div className={theme === 'dark' ? 'main-content_dark' : 'main-content'}>
                <div className="row">
                    <div className="col-10 px-4">
                        <label className='head'>{t('WorkPlaceExceptions')}</label>
                    </div>
                    <div className="col-2 right px-4  ">
                        <Menu>
                            <MenuTrigger disableButtonEnhancement>
                                <Avatar
                                    name={localStorage.getItem('UserName')?.toString()}
                                    image={{
                                        src: getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                            ? getSettingsData.data.UserImage.Value
                                            : "",
                                    }}
                                    style={{
                                        cursor: "pointer", width: "45px", height: "43px"
                                    }}
                                    shape="circular"
                                />
                            </MenuTrigger>
                            <MenuPopover className='mt-2' style={{ width: "14rem" }}>
                                <MenuList>
                                    {/* <MenuItem style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={CommonInfo.folderName + "resetpassword.svg"} />&nbsp;&nbsp;Reset password</MenuItem> */}
                                    <MenuItem onClick={logOut} style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Logoutlight.svg' : '/logout.svg'}`}
                                    />&nbsp;&nbsp;{t('LogOut')}</MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>
                        {ToastrService.getToastrComponent()}

                    </div>
                </div>
                <div className="container">
                    <div className="row mt-5">
                        <div className="col-xl-1 col-lg-0 col-md-0 col-sm-0"></div>
                        <div className="col-xl-9 col-lg-10 col-md-12 col-sm-12">
                            {dateRanges.map((range, index) => (
                                <div key={index} className={theme === 'dark' ? 'row mb-2 px-0 svg_dark' : "row mb-2 px-0"}>
                                    <div className={theme === 'dark' ? 'col-xl-3 col-lg-3 col-md-3 col-sm-3 date_picker_darker' : "col-xl-3 col-lg-3 col-md-3 col-sm-3 date_picker"}>
                                        <div className='col-12'>
                                            <DatePicker disabled={dateRanges.length > 1 && index !== currentIndex}
                                                value={dateFormat === 'DD/MM/YYYY' && range.Date ? dayjs(range.Date, dateFormat) : range.Date ? dayjs(range.Date) : null}
                                                //    value={range.Date ? dayjs(range.Date,dateFormat) : null}
                                                onChange={(date: any, dateStrings) => handleDateChange(date, dateStrings, index)}
                                                disabledDate={isDayDisabled}

                                                onClick={openCalendar}
                                                format={dateFormat}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-5 mt-3 ">
                                        <div className={'col-12 d-flex align-items-center time_picker'}>
                                            <CustomTimePicker disabled={dateRanges.length > 1 && index !== currentIndex}
                                                onTimeChange={(event, data) => handleTimeChange(index, 'StartDateTime', data)}
                                                style={{ height: "41px", backgroundColor: theme === 'dark' ? '#1A1A1A' : "#fff" }} value={range.StartDateTime} isFormattedTime={is24HrFormat} />
                                            <span className="mx-2">{t('To')}</span>
                                            <CustomTimePicker disabled={dateRanges.length > 1 && index !== currentIndex}
                                                style={{ height: "40px", backgroundColor: theme === 'dark' ? '#1A1A1A' : "#fff" }} value={range.EndDateTime}
                                                onTimeChange={(event, data) => handleTimeChange(index, 'EndDateTime', data)} isFormattedTime={is24HrFormat} />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-2 col-md-3 col-sm-3 mt-3">
                                        <div className='col-12'>
                                            <CustomOptionsDropdown
                                                workplaceList={getSettingsData.workPlacelist}
                                                style={{ height: "40px", backgroundColor: theme === 'dark' ? '#1A1A1A' : "#fff", textWrap: "nowrap" }}
                                                value={range?.WorkingPlace} disabled={dateRanges.length > 1 && index !== currentIndex}
                                                onOptionSelect={(event, data) => handleDropdownChange(index, data.optionValue)} />
                                        </div>
                                    </div>
                                    <div className="col-xl-1 col-lg-2 col-md-2 col-sm-1 mt-3" style={{ textWrap: "nowrap" }}>
                                        {index === 0 && <button type="button" onClick={goBack} className={theme === 'dark' ? 'bttn_dark' : 'bttn'} ><FontAwesomeIcon icon={faCancel} />&nbsp;&nbsp;{t('Cancel')}</button>
                                        }
                                        {index === 0 && <button disabled={currentIndex !== 0} className={theme === 'dark' ? 'update_button_dark' : 'update_button'} onClick={() => handleSave(range.Date, range.StartDateTime, range.EndDateTime, range.WorkingPlace, range.Id, index)} ><FontAwesomeIcon icon={faSave} className='icon' />{t('Save')}</button>
                                        }
                                        {index !== 0 && <FontAwesomeIcon icon={currentIndex === index ? faSave : faEdit} onClick={() => currentIndex === index ?
                                            handleSave(range.Date, range.StartDateTime, range.EndDateTime, range.WorkingPlace, range.Id, index) : getIndex(range.Date, range.StartDateTime, range.EndDateTime, range.WorkingPlace, range.Id, index)} className="icon pointer" style={{ marginTop: "12px" }} />
                                        }
                                        {index !== 0 && (currentIndex !== index) && <DeleteAction className='paddleft1 pointer' deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={range.Date + ' at ' + range.StartDateTime + '-' + range.EndDateTime}
                                            triggerdelete={() => handleDelete(range.Date, range.StartDateTime, range.EndDateTime, range.WorkingPlace, range.Id, index)} />}
                                    </div>
                                </div>


                            ))}

                        </div>
                        <div className='Btn_class mt-5'>
                            {dateRanges.length > 10 && dateRanges.length < allExceptions.length && <button type="button" onClick={handleLoadMore} className={theme === 'dark' ? 'load_bttn_dark' : 'load_bttn'} >... &nbsp;{t('LoadMore')}</button>}
                            &nbsp;&nbsp;&nbsp;&nbsp;{count > 0 && <button type="button" onClick={handleLoadLess} className={theme === 'dark' ? 'load_bttn_dark' : 'load_bttn'} >{t('ShowLess')} &nbsp;...</button>}

                        </div>
                        <div className="col-xl-0 col-lg-0 col-md-0 col-sm-0"></div>

                    </div>


                </div>
            </div>
        </div>
    );

};

export default WorkSpaceExcption;